import { OrganisationResponse, OrganisationTinyResponse } from '@joc/api-gateway';

export const getListVolunteers = (
	arr: Array<OrganisationResponse | OrganisationTinyResponse>,
	defaultOrganizationId?: string
) => {
	const defaultOrg = arr.find(org => org.id === defaultOrganizationId);
	const initArr: Array<string> = [...(defaultOrg ? [defaultOrg?.organizationName] : [])];

	const resultList = Array.from(
		new Set(
			arr
				.filter(org => (defaultOrg ? defaultOrg.id !== org.id : org))
				.reduce((accumulator, currentValue) => [...accumulator, currentValue.organizationName], initArr)
				.filter(Boolean)
		)
	);

	return [...resultList].join(', ');
};
